import apiEnrollmentInfos from '@/api/enrollment'

const state = {
  error: null,
  isSubmitting: false,
}

export const mutationTypes = {
  updateEnrollmentDocumentsStart:
    '[enrollmentInfo] Update Documents enrollmentInfo start',
  updateEnrollmentDocumentsSuccess:
    '[enrollmentInfo] Update Documents enrollmentInfo success',
  updateEnrollmentDocumentsFailure:
    '[enrollmentInfo] Update Documents enrollmentInfo failure',
}

export const actionTypes = {
  updateEnrollmentDocuments: '[enrollmentInfo] Update documents enrollmentInfo',
}

const mutations = {
  [mutationTypes.updateEnrollmentDocumentsStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.updateEnrollmentDocumentsSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.updateEnrollmentDocumentsFailure](state) {
    state.isSubmitting = false
  },
}

const actions = {
  [actionTypes.updateEnrollmentDocuments](context, {feedbackId, data}) {
    context.commit(mutationTypes.updateEnrollmentDocumentsStart)
    return new Promise((resolve) => {
      apiEnrollmentInfos
        .changeEnrollmentDocuments(feedbackId, data)
        .then((response) => {
          context.commit(
            mutationTypes.updateEnrollmentDocumentsSuccess,
            response.data
          )
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.updateEnrollmentDocumentsFailure)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
